export enum TrainingType {
  TRAINING = 'training',
  EVENT = 'event',
}
